import React, { useState } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { LtiRedirect } from './LtiRedirect'
import ButterToast, { Cinnamon } from 'butter-toast'
import { ActivitiesContainer } from './activities/Container'
import { ReadingLinksContainer } from './readinglinks/Container'

const ResourceSelectionComp = () => {
  const [currentState, dispatch] = useStateValue()
  const [redirect, setRedirect] = useState(null)
  const [selectedTitleIds, setSelectedTitleIds] = useState([])
  const [selectedActIds, setSelectedActIds] = useState([])
  const [selectedReadingIds, setSelectedReadingIds] = useState([])

  const addResource = async () => {
    try {
      const resp = await client.post(
        '/lti13/resource_selection.get_resource_jwt/',
        {
          title_page_links: selectedTitleIds,
          activity_ids: selectedActIds,
          reading_nodes: selectedReadingIds.map(readingId => {
            for (const course of currentState.connectedCourses) {
              const selectedNode = course.nodeMap[readingId] || null
              if (selectedNode) {
                selectedNode['coursenum'] = course.coursenum
                return selectedNode
              }
            }
            return null
          }),
        }
      )
      setRedirect(resp.data) // this triggers the redirect and form auto-submission
    } catch (err) {
      let errMsg = err
      if (err.response) {
        errMsg = err.response.data.error
      }
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={errMsg}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        sticky: true,
      })
      setRedirect(null)
    }
  }

  const handleActCheck = event => {
    const targetId = event.target.value
    const itemIdx = selectedActIds.indexOf(targetId)
    if (itemIdx > -1) {
      selectedActIds.splice(itemIdx, 1)
    } else {
      selectedActIds.push(targetId)
    }
    if (currentState.multiSelectEnabled) {
      setSelectedActIds([...selectedActIds])
    } else {
      setSelectedActIds([targetId])
      setSelectedTitleIds([])
      setSelectedReadingIds([])
    }
  }

  const handleReadingCheck = event => {
    const targetId = event.target.value
    const itemIdx = selectedReadingIds.indexOf(targetId)
    if (itemIdx > -1) {
      selectedReadingIds.splice(itemIdx, 1)
    } else {
      selectedReadingIds.push(targetId)
    }
    if (currentState.multiSelectEnabled) {
      setSelectedReadingIds([...selectedReadingIds])
    } else {
      setSelectedReadingIds([targetId])
      setSelectedTitleIds([])
      setSelectedActIds([])
    }
  }

  const handleTitleCheck = event => {
    const targetId = event.target.value
    const itemIdx = selectedTitleIds.indexOf(targetId)
    if (itemIdx > -1) {
      selectedTitleIds.splice(itemIdx, 1)
    } else {
      selectedTitleIds.push(targetId)
    }
    if (currentState.multiSelectEnabled) {
      setSelectedTitleIds([...selectedTitleIds])
    } else {
      setSelectedTitleIds([targetId])
      setSelectedReadingIds([])
      setSelectedActIds([])
    }
  }

  return (
    <React.Fragment>
      <div className="mt-5">
        {!currentState.assessmentsOnly && !currentState.readingLinksOnly && (
          <div>
            <ul className="nav nav-tabs nav-tabs-embedded">
              <li
                className={currentState.currentPage === 'reading' && 'active'}
              >
                <a
                  onClick={() => {
                    dispatch({
                      type: 'updateCurrentPage',
                      currentPage: 'reading',
                    })
                  }}
                >
                  Reading Links
                </a>
              </li>
              <li
                className={
                  currentState.currentPage === 'assignment' && 'active'
                }
              >
                <a
                  onClick={() => {
                    dispatch({
                      type: 'updateCurrentPage',
                      currentPage: 'assignment',
                    })
                  }}
                >
                  Assessments
                </a>
              </li>
            </ul>
          </div>
        )}
        {
          {
            assignment: (
              <ActivitiesContainer
                selectedResourceIds={selectedActIds}
                handleCheck={handleActCheck}
              />
            ),
            reading: (
              <ReadingLinksContainer
                selectedResourceIds={selectedReadingIds}
                handleCheck={handleReadingCheck}
                selectedTitleIds={selectedTitleIds}
                handleTitleCheck={handleTitleCheck}
              />
            ),
          }[currentState.currentPage]
        }

        <hr />

        <div className="d-flex justify-content-between">
          <div className="pt-1">
            <button
              disabled={
                selectedActIds.length === 0 &&
                selectedReadingIds.length === 0 &&
                selectedTitleIds.length == 0
              }
              className="btn btn-myed btn-primary btn-primary-myed"
              onClick={addResource}
            >
              Add{' '}
              {selectedActIds.length +
                selectedReadingIds.length +
                selectedTitleIds.length}{' '}
              Link
              {selectedActIds.length +
                selectedReadingIds.length +
                selectedTitleIds.length ==
              1
                ? ''
                : 's'}
            </button>
            <div className="meta-info-container">
              {(selectedTitleIds.length > 0 ||
                selectedActIds.length > 0 ||
                selectedReadingIds.length > 0) && (
                <ul>
                  {selectedTitleIds.length > 0 && (
                    <li>
                      {`${selectedTitleIds.length} title link${
                        selectedTitleIds.length > 1 ? 's' : ''
                      } selected`}
                    </li>
                  )}
                  {selectedReadingIds.length > 0 && (
                    <li>
                      {`${selectedReadingIds.length} reading link${
                        selectedReadingIds.length > 1 ? 's' : ''
                      } selected`}
                    </li>
                  )}
                  {selectedActIds.length > 0 && (
                    <li>
                      {`${selectedActIds.length} assignment${
                        selectedActIds.length > 1 ? 's' : ''
                      } selected`}
                    </li>
                  )}
                </ul>
              )}
            </div>

            <LtiRedirect
              route_method="POST"
              route_action={redirect && redirect.route_action}
              route_data={redirect && redirect.route_data}
            />
          </div>
        </div>
        <div className="pull-right mr-4">
          <Link
            variant="gray-primary"
            to={`/lti13/resource_selection/-/${currentState.contextObjId}/connect_resource${window.location.search}`}
          >
            Connect Another Resource
          </Link>
        </div>
      </div>
    </React.Fragment>
  )
}

export const ResourceSelection = withRouter(ResourceSelectionComp)
